import React from 'react';

import Modal from 'components/Modal';
import { Text, Box } from 'components/library';

import * as S from './styled';

import { IWaitingModal } from 'types/modals';

import SandClock from './images/sandClock.svg';

const WaitingModal = ({ captions, dataLocator }: IWaitingModal) => (
    <Modal isOpen dataLocator={dataLocator}>
        <S.Container $paddingTop={20} $paddingBottom={20} $paddingX={20}>
            <SandClock />
            <Text type="h5" bold center mb={24}>
                {captions.title}
            </Text>
            {captions.subtitle && (
                <Text center mb={24}>
                    {captions.subtitle}
                </Text>
            )}
            <Box>
                <S.Spinner />
            </Box>
        </S.Container>
    </Modal>
);

export default WaitingModal;
